import "./App.scss";
import "./responsive.scss";
import React, { useState, useEffect, useRef } from "react";
import { TrashIcon } from "./icons";
import { toast, ToastContainer } from "react-toastify";

export default function App() {
  const initialList = [
    "Zar at 🎲",
    "Şarkı söyle 🎙",
    "Dans et 🕺🏻",
    "Taklit yap 🤪",
    "Alkışla 👏🏻",
  ];
  const [list, setList] = useState(initialList);

  const [addName, setAddName] = useState("");
  const [radius, setRadius] = useState(75);
  const [rotate, setRotate] = useState(0);
  const [easeOut, setEaseOut] = useState(0);
  const [angle, setAngle] = useState(0);
  const [top, setTop] = useState(null);
  const [offset, setOffset] = useState(null);
  const [net, setNet] = useState(null);
  const [result, setResult] = useState(-1);
  const [spinning, setSpinning] = useState(false);

  useEffect(() => {
    clearSector();
    let numOptions = list.length;
    let arcSize = (2 * Math.PI) / numOptions;
    setAngle(arcSize);
    //topPosition(numOptions, arcSize);
    let angle = 0;
    for (let i = 0; i < numOptions; i++) {
      let text = list[i];
      renderSector(i + 1, text, angle, arcSize, getColor());
      angle += arcSize;
    }
  }, [list]);

  const topPosition = (num, angle) => {
    let topSpot = null;
    let degreesOff = null;
    if (num === 9) {
      topSpot = 7;
      degreesOff = Math.PI / 2 - angle * 2;
    } else if (num === 8) {
      topSpot = 6;
      degreesOff = 0;
    } else if (num <= 7 && num > 4) {
      topSpot = num - 1;
      degreesOff = Math.PI / 2 - angle;
    } else if (num === 4) {
      topSpot = num - 1;
      degreesOff = 0;
    } else if (num <= 3) {
      topSpot = num;
      degreesOff = Math.PI / 2;
    }

    setTop(topSpot - 1);
    setOffset(degreesOff);
  };

  function renderSector(index, text, start, arc, color) {
    let canvas = document.getElementById("wheel");
    let ctx = canvas.getContext("2d");
    ctx.globalCompositeOperation = "destination-over";
    let x = canvas.width / 2;
    let y = canvas.height / 2;
    let startAngle = start;
    let endAngle = start + arc;
    let angle = index * arc;
    let baseSize = radius * 3.33;
    let textRadius = baseSize - 150;

    ctx.beginPath();
    ctx.arc(x, y, radius, startAngle, endAngle, false);
    ctx.lineWidth = radius * 2;
    ctx.strokeStyle = color;

    ctx.font = "bold 17px Montserrat";
    ctx.fillStyle = "black";
    ctx.stroke();

    ctx.save();
    ctx.translate(
      baseSize + Math.cos(angle - arc / 2) * textRadius,
      baseSize + Math.sin(angle - arc / 2) * textRadius
    );
    ctx.rotate(angle - arc / 2 + Math.PI / 2);
    ctx.fillText(text, -ctx.measureText(text).width / 2, 0);
    ctx.restore();
  }

  function clearSector() {
    let canvas = document.getElementById("wheel");
    let ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  }

  function getColor() {
    let r = Math.floor(Math.random() * 255);
    let g = Math.floor(Math.random() * 255);
    let b = Math.floor(Math.random() * 255);
    return `rgba(${r},${g},${b}, 0.6)`;
  }

  const spin = () => {
    if (spinning || list.length <= 1) {
      return null;
    }
    let randomSpin = Math.floor(Math.random() * 900) + 500;

    setRotate(randomSpin);
    setEaseOut(2);
    setSpinning(true);

    setTimeout(() => {
      getResult(randomSpin);
    }, 2000);
  };

  const getResult = (spin) => {
    let netRotation = ((spin % 360) * Math.PI) / 180;
    let travel = netRotation + offset;
    let count = top + 1;
    while (travel > 0) {
      travel = travel - angle;
      count--;
    }
    let result;
    if (count >= 0) {
      result = count;
    } else {
      result = list.length + count;
    }

    setSpinning(false);
    setNet(netRotation);
    setResult(result);
  };

  const addToList = (e) => {
    e.preventDefault();
    if (spinning) {
      return null;
    }
    var alreadyExists = list.filter((i) => i == addName).length > 0;
    if (alreadyExists) {
      toast.error("Böyle bir seçenek zaten bulunuyor!");

      return null;
    }
    setList([...list, addName]);
    setAddName("");
  };

  const removeFromList = (name) => {
    if (spinning || list.length == 1) {
      if (list.length == 1) {
        toast.error("En az 1 adet seçenek olmalıdır!");
      }
      return null;
    }
    setList([...list.filter((i) => i != name)]);
  };

  const reset = () => {
    toast.success("Sıfırlama işlemi başarılı.");
    setList(initialList);
    setRotate(0);
    setEaseOut(0);
    setResult(null);
    setSpinning(false);
  };

  return (
    <div className="App">
      <ToastContainer
        style={{ position: "fixed" }}
        position="bottom-right"
        autoClose={2500}
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover
        draggable
      />

      <h1 className="title text-shadow">
        <span>Şans</span> Çarkı
      </h1>
      <div className="wheel-wrapper">
        <canvas
          draggable={false}
          onClick={() => spin()}
          id="wheel"
          width="500"
          height="500"
          style={{
            WebkitTransform: `rotate(${rotate}deg)`,
            WebkitTransition: `-webkit-transform ${easeOut}s ease-out`,
          }}
        />
        <span className="selector text-shadow">&#9650;</span>
      </div>

      <button className="spin-button box-shadow" onClick={() => spin()}>
        Döndür
      </button>

      <div className="result">
        {result >= 0 && (
          <>
            <span className="result-title">Sonuç</span>{" "}
            <span className="result-text">{list[result]}</span>
          </>
        )}
      </div>

      <div className="options box-shadow">
        <form action="#" onSubmit={addToList} className="add-form">
          <input
            type="text"
            className="add-form-input box-shadow"
            value={addName}
            onChange={(e) => setAddName(e.currentTarget.value)}
            placeholder="Çarka seçenek ekle"
          />
          <button type="submit" className="add-form-button box-shadow">
            Ekle
          </button>
        </form>
        <div className="list-wrapper">
          {list.map((item, index) => (
            <div className="object" key={index}>
              <div className="object-text">{item}</div>
              <span className="object-delete">
                <TrashIcon onClick={() => removeFromList(item)} />
              </span>
            </div>
          ))}
        </div>
        <button className="reset box-shadow" onClick={() => reset()}>
          Sıfırla
        </button>
      </div>

      <div className="footer">
        <div className="footer-copyright">
          Ⓒ 2021{" "}
          <span className="footer-first">
            ŞANS<span className="footer-last">ÇARKI</span>
          </span>{" "}
          /<span className="footer-rights">Tüm hakları saklıdır.</span>
        </div>
      </div>
    </div>
  );
}
